export default {
  data() {
    return {
      bgOpacity: false
    };
  },
  props: {
    imgHeight: {
      type: Number,
      default: 525
    },
    srcCover: {
      type: String,
      default: ''
    }
  },
  mounted() {
    setTimeout(() => {
      this.bgOpacity = true;
    }, 18);
  }
};